import type { NewKegTap, TapBoard } from '../../types/kegTaps'
import { request } from './http'

export const getTapBoard = () => request<TapBoard>('/keg-taps')

export const createKegTap = (body: NewKegTap) => request<{ id: number }>('/keg-taps', { method: 'POST', body: JSON.stringify(body) })

export const deleteKegTap = (id: number) => request<{ id: number }>(`/keg-taps/${id}`, { method: 'DELETE' })
